export default __webpack_public_path__ + "static/media/pat-knet.01268412.svg";